import { BaseService } from '../../infra/base.service'
import type { PosReportsRepository } from './reports.repository'

export class PosReportsService extends BaseService<any> {
    constructor(private rep: PosReportsRepository) {
        super(rep)
    }

    async InvoicesPersonsPending(from: Date, to: Date) {
        return await this.rep.InvoicesPersonsPending(from, to)
    }
    async InvoicesPersonsAll(from: Date, to: Date) {
        return await this.rep.InvoicesPersonsAll(from, to)
    }
}
